module.exports = __webpack_public_path__ + "img/TM-Funky.7bfa8bf8.png";